import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { AuthShell, Field, FormError } from "./AuthShell";
import { api, formatApiError } from "../../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="Enter your account email and we'll send you a reset link." testid="forgot-page">
      <title>Forgot password | Vata Infrastructures</title>
      {sent ? (
        <div data-testid="forgot-success" className="border-l-4 border-[var(--forest)] bg-white p-5">
          <MailCheck className="h-6 w-6 text-[var(--forest)]" />
          <p className="mt-3 font-semibold">Check your inbox</p>
          <p className="mt-1 text-sm text-[var(--muted-ink)]">If an account exists for {email}, a reset link is on its way. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field id="fp-email" label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          <FormError error={error} />
          <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-4 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
          </button>
        </form>
      )}
      <p className="mt-8 text-sm"><Link to="/login" data-testid="forgot-login-link" className="font-semibold underline">Back to sign in</Link></p>
    </AuthShell>
  );
}
